import React, { useState, useEffect } from 'react';
import ContactBar from '../contact-bar';
import Theme from '../theme';

import './index.css';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/common/name-header.json`;

    const [content, setContent] = useState({
        name: 'Dr. Raju Halder',
        designation: 'Associate Professor',
        department: 'Department of Computer Science & Engineering',
        organization: 'Indian Institute of Technology Patna, India',
        email: { username: 'halder', domain: ['iitp', 'ac', 'in'] }
    });

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div className="Name-Heading row justify-content-center">
            <div className="theme-box">
                <Theme />
            </div>
            <div className="photo col-lg-3 col-12">
                <img alt="profile" src={`${process.env.PUBLIC_URL}/_static/profile.jpg`} />
            </div>
            <div className="name-text col-lg-4 col-12">
                <h2>{content.name}</h2>
                <h4>{content.designation}</h4>
                <h5>{content.department}</h5>
                <h5>{content.organization}</h5>
                <p>
                    <i className="fas fa-envelope-open-text" /> {content.email.username}
                    <i className="fas fa-at" />
                    {content.email.domain.map((item, index) => {
                        if (index !== content.email.domain.length - 1)
                            return <span key={index}>{item}&bull;</span>;

                        return <span key={index}>{item}</span>;
                    })}
                </p>
            </div>
            <div className="text col-lg-4 col-12">
                <ContactBar />
            </div>
        </div>
    );
};

export default Component;
